import { ElementType } from 'react'

import { Breadcrumb, BreadcrumbType, CategorySub } from '@karakuri-web/faq-type'

import { Breadcrumbs } from './Breadcrumbs'
import { BreadcrumbsList } from './BreadcrumbsList'
import { Tag, TagCloud } from './TagCloud'

/**
 * パンくずリスト
 * -
 * breadcrumbTypeとレイアウトと場所によって、`/category`か`/search`から始まるパスを生成する
 * - breadcrumb:
 *   - カテゴリページの場合: `/category`から始まるパスを生成する。
 *   - 検索ページの場合: `/search`から始まるパスを生成する。
 *   - 回答ページの場合: hierarchiesに応じて、動的にパスを生成する。
 * - breadcrumbAll:
 *   - 常に、`/category`から始まるパスを生成する
 * - tag:
 *   - NaviWidgetの場合: `/category`から始まるパスを生成する。
 *   - BreadcrumbWidgetの場合: `/search`から始まるパスを生成する。
 *
 * TODO: パンくずリストの種類によって振る舞いが異なるため要整理。
 */
export function BreadcrumbsNavigation({
  breadcrumbType,
  breadcrumb,
  relatedCategories = [],
  topTitle,
  tags = [],
  LinkComponent,
  onLinkClick,
}: {
  breadcrumbType?: BreadcrumbType | null
  breadcrumb?: Breadcrumb
  relatedCategories?: CategorySub[]
  topTitle: string
  tags?: Tag[]
  LinkComponent?: ElementType
  onLinkClick?: (link: string, option: any) => void
}) {
  switch (breadcrumbType) {
    case 'tag':
      return <TagCloud tags={tags} LinkComponent={LinkComponent} onLinkClick={onLinkClick} />
    case 'breadcrumbAll':
      return breadcrumb ? (
        <BreadcrumbsList
          {...breadcrumb}
          relatedCategories={relatedCategories}
          topTitle={topTitle}
          LinkComponent={LinkComponent}
          onLinkClick={onLinkClick}
        />
      ) : null

    case 'breadcrumb':
      return breadcrumb ? (
        <Breadcrumbs
          {...breadcrumb}
          topTitle={topTitle}
          LinkComponent={LinkComponent}
          onLinkClick={onLinkClick}
        />
      ) : null

    default:
      return null
  }
}
